import { Component, OnInit } from '@angular/core';
import { UserService } from '../_services/user.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { User } from '../_models';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {
  isCustomerSelected: boolean = false;
  isCSPUser: boolean = false;
  isAdminUser: boolean = false;
  loading: boolean = false;
  isCompanyRequired: boolean = false;
  CompanyName: string;
  fieldTextType: boolean;
  lastSavedRole: string;
  cUser: User;
  constructor(
    public service: UserService,
    private notifyService: NotificationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}
  submitted: boolean = false;
  ngOnInit(): void {
     console.log("Register component loaded");

  console.log(localStorage.getItem('currentUser'));
    this.cUser = JSON.parse(localStorage.getItem('currentUser'));
    this.CompanyName = '';
    this.isCSPUser = this.cUser.roles == 'CSP' ? true : false;
    this.isCustomerSelected = this.isCSPUser == true ? true : false;
    this.isAdminUser = this.cUser.roles == 'Admin' ? true : false;
    this.onRoleChange();
  }

  formModel = this.fb.group({
    Role: ['Customer', Validators.required],
    UserName: ['', [Validators.required, Validators.minLength(6)]], //min length should be 6
    Email: ['', [Validators.required, Validators.email]],
    FirstName: [''],
    LastName: [''],
    Mobile: [''],
    PartnerCenterId: ['', Validators.required], // new field
    //  Mobile: ['',[Validators.required,Validators.maxLength,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
    Passwords: this.fb.group(
      {
        Password: ['', [Validators.required, Validators.minLength(6)]],
        ConfirmPassword: ['', Validators.required],
      },
      { validator: this.comparePasswords }
    ),
  });

  comparePasswords(fb: FormGroup) {
    let confirmPswrdCtrl = fb.get('ConfirmPassword');
    //passwordMismatch
    //confirmPswrdCtrl.errors={passwordMismatch:true}
    if (
      confirmPswrdCtrl.errors == null ||
      'passwordMismatch' in confirmPswrdCtrl.errors
    ) {
      if (fb.get('Password').value != confirmPswrdCtrl.value)
        confirmPswrdCtrl.setErrors({ passwordMismatch: true });
      else confirmPswrdCtrl.setErrors(null);
    }
  }

  // onRoleChange() {
  //   this.isCustomerSelected =
  //     this.formModel.value.Role == 'Customer' ? true : false;
  // }

  onRoleChange() {
  this.isCustomerSelected =
    this.formModel.value.Role == 'Customer' ? true : false;

  const partnerControl = this.formModel.get('PartnerCenterId');

  if (this.isCustomerSelected) {
    partnerControl.setValidators([Validators.required]);
  } else {
    partnerControl.clearValidators();
    partnerControl.setValue('');
  }

  partnerControl.updateValueAndValidity();
}
  /* Handle form errors in Angular */
  public hasError = (controlName: string, errorName: string) => {
    return this.formModel.controls[controlName].hasError(errorName);
  };

  onSubmit() {
    this.submitted = true;

    if (this.isCustomerSelected) {
      if (this.CompanyName == '') {
        this.isCompanyRequired = true;
      }
    }

    if (!this.formModel.valid) {
      //  this.notifyService.showError("All fields are required.", "Error.")
      return;
    }
    var param = {
      UserName: this.formModel.value.UserName,
      Mobile: this.formModel.value.Mobile,
      CompanyName: this.CompanyName,
      Email: this.formModel.value.Email,
      FirstName: this.formModel.value.FirstName,
      LastName: this.formModel.value.LastName,
      Password: this.formModel.value.Passwords.Password,
      ConfirmPassword: this.formModel.value.Passwords.ConfirmPassword,
      Role: this.formModel.value.Role,
      CreatedBy: this.cUser.userId,
      PartnerCenterId: this.formModel.value.PartnerCenterId, // added
    };
    //console.log(param);
    this.lastSavedRole = this.formModel.value.Role;
    this.loading = true;
    this.service.register(param).subscribe(
      (res: any) => {
        if (res.code == 200) {
          this.formModel.reset();
          this.loading = false;
          this.submitted = false;

          this.formModel.controls.Role.setValue(this.lastSavedRole);
          this.CompanyName = '';
          this.isCustomerSelected = false;
          this.notifyService.showSuccess(
            'New user created!',
            'Registration successful.'
          );
        } else {
          res.errors.forEach((element) => {
            switch (element.code) {
              case 'DuplicateUserName':
                this.notifyService.showError(
                  'Username is already taken',
                  'Registration failed.'
                );
                break;

              default:
                this.notifyService.showError(
                  element.description,
                  'Registration failed.'
                );
                break;
            }
          });
          this.loading = false;
          this.submitted = false;
        }
      },
      (err) => {
        this.loading = false;
        this.submitted = false;
        this.notifyService.showError(err, 'Registration failed.');
      }
    );
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  onClose() {
    this.location.back();
    // this.router.navigate(['/customers']);
  }
}
